import React, { useEffect } from 'react'
import logo from "../../../../assets/Icons/ksrtc-logo.png";
import moment from 'moment';

const BkgPrintTicket = ({ onPrint, setIsPrint, isPrint = false, ticketData = {} }) => {
    const handlePrint = () => {
        setIsPrint(false);
        const divContents = document.getElementById("bkgAdvPrint")?.innerHTML;
        const iframe1 = document.createElement("iframe");
        iframe1.style.display = "none";
        document.body.appendChild(iframe1);
        iframe1.contentDocument.write(divContents);
        iframe1.contentDocument.close();
        iframe1.contentWindow.print();
        document.body.removeChild(iframe1);
        // window.print(); // This will trigger the browser's print dialog
    };

    useEffect(() => {
        if (isPrint && Object.keys(ticketData).length > 0) {
            setTimeout(() => {
                if (Object.keys(ticketData).length > 0) {
                    handlePrint();
                }
            }, 100);

        }
    }, [isPrint, ticketData]);

    const col1 = [
        { label: "ಪ್ರಯಾಣದ ದಿನಾಂಕ / Date of Journey", val: "JourneyDate" },
        { label: "ಪ್ರಾರ೦ಭ ಸ್ಥಳ / Start Place", val: "FromCity" },
        { label: "ನಿರ್ಗಮನ ವೇಳೆ / Departure Time", val: "DepartTimeOnly" },
        { label: "ಗಮ್ಯ ಸ್ಥಳ/End Place", val: "ToCity" },
    ];

    const col2 = [
        { label: "ಟ್ರಿಪ್‍ಕೋಡ್ / Trip Code", val: "TripCodeMaster" },
        { label: "ಪಿಕಪ್ ಪಾಯಿಂಟ್ / Pickup Point", val: "PickupName" },
        { label: "ಅಂಕಣ ಸಂಖ್ಯೆ / Platform No.", val: "PlatFormNo" },
        { label: "ಪ್ರಯಾಣಿಕರು ಇಳಿಯುವ ಸ್ಥಳ / Dropping Point", val: "DropoffName" },
    ];

    const col3 = [
        { label: "ವರ್ಗ / Class", val: "ServiceTypeName" },
        { label: "ಸಂಪರ್ಕ ಸಂಖ್ಯೆ/Contact No.:", val: "PickupContactNo" },
    ];
    return (
        <>
            {Object.keys(ticketData).length > 0 &&
                <div id='bkgAdvPrint' style={{ display: 'none' }}>
                    <div
                        className="ticker-container"
                        style={{
                            width: "1122px", height: "793px",
                            border: "2px dotted #004F9E",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                backgroundColor: "#004F9E",
                                textAlign: "center",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "12px",
                                width: "100%",
                            }}
                        >
                            <div className="logo">
                                {/* Your logo component or image */}
                                <img
                                    src={logo}
                                    alt="Logo"
                                    style={{
                                        height: "86px",
                                        width: "86px",
                                    }}
                                />
                            </div>

                            <p
                                style={{
                                    color: "#FFFFFF",
                                    fontSize: "18px",
                                    lineHeight: "25.78px",
                                    fontWeight: "600",
                                }}
                            >
                                ಕರ್ನಾಟಕ ರಾಜ್ಯ ರಸ್ತೆ ಸಾರಿಗೆ ಸಂಸ್ಥೆ / Karnataka State Road Transport
                                Corporation
                                <br />
                                ಮುಂಗಡ ಆಸನ ಕಾಯ್ದಿರಿಸಿದ ಚೀಟಿ / Reservation Ticket
                            </p>
                            <p
                                style={{
                                    color: "#FFFFFF",
                                    fontSize: "18px",
                                    lineHeight: "21.78px",
                                    fontWeight: "600",
                                }}
                            >
                                Punch
                                <br />
                                Used
                                <br />
                                Tickets
                            </p>
                        </div>
                        <div>
                            <div
                                style={{ display: "flex", justifyContent: "space-between", borderBottom: "2px dotted #000000", padding: '0px 5px' }}
                            >
                                <p
                                    style={{
                                        fontSize: "14px",
                                        lineHeight: "20px",
                                        fontWeight: "500",
                                        whiteSpace: "nowrap",
                                        color: "#000000",
                                    }}
                                >
                                    ಪಿ.ಎನ್.ಆರ್. ಸಂಖ್ಯೆ / PNR No:&nbsp;
                                    <span
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "24px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        {ticketData?.BookingRefNo || ''}
                                    </span>
                                </p>
                                <p
                                    style={{
                                        fontSize: "14px",
                                        lineHeight: "20px",
                                        fontWeight: "500",
                                        whiteSpace: "nowrap",
                                        color: "#000000",
                                    }}
                                >
                                    ಟಿಕೇಟು ಸಂಖ್ಯೆ / Ticket No:&nbsp;
                                    <span
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "24px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        {ticketData?.TicketNo || ''}
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div
                            className="information"
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: 'start',
                                padding: '0px 5px'
                            }}
                        >
                            <div>
                                {col1?.map((obj) => (
                                    <div key={obj.label}>
                                        <p
                                            style={{
                                                fontSize: "14px",
                                                lineHeight: "20px",
                                                fontWeight: "500",
                                                whiteSpace: "nowrap",
                                                color: "#000000",
                                            }}
                                        >
                                            {obj.label}
                                        </p>
                                        <p
                                            style={{
                                                fontSize: "16px",
                                                lineHeight: "24px",
                                                fontWeight: "500",
                                                whiteSpace: "nowrap",
                                                color: "#000000",
                                            }}
                                        >
                                            {ticketData?.[obj.val] || ` `}
                                        </p>
                                    </div>
                                ))}
                                <div>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಒಟ್ಟು ಆಸನಗಳು / Total Seats: M:{ticketData?.MaleSeat},F:{ticketData?.FemaleSeat},C:{ticketData?.ChildSeatCount}
                                    </p>
                                </div>
                            </div>
                            <div >
                                {col2?.map((obj) => (
                                    <div key={obj.label}>
                                        <p
                                            style={{
                                                fontSize: "14px",
                                                lineHeight: "20px",
                                                fontWeight: "500",
                                                whiteSpace: "nowrap",
                                                color: "#000000",
                                            }}
                                        >
                                            {obj.label}
                                        </p>
                                        <p
                                            style={{
                                                fontSize: "16px",
                                                lineHeight: "24px",
                                                fontWeight: "500",
                                                whiteSpace: "nowrap",
                                                color: "#000000",
                                            }}
                                        >
                                            {ticketData?.[obj.val] || ' '}
                                        </p>
                                    </div>
                                ))}
                                <div style={{ padding: '8px 0px' }}>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಆಸನ ಸಂಖ್ಯೆ / Seat Numbers: {ticketData?.SeatNos || ''}
                                    </p>
                                </div>
                            </div>
                            <div >
                                {col3?.map((obj) => (
                                    <div key={obj.label}>
                                        <p
                                            style={{
                                                fontSize: "14px",
                                                lineHeight: "20px",
                                                fontWeight: "500",
                                                whiteSpace: "nowrap",
                                                color: "#000000",
                                            }}
                                        >
                                            {obj.label}
                                        </p>
                                        <p
                                            style={{
                                                fontSize: "16px",
                                                lineHeight: "24px",
                                                fontWeight: "500",
                                                whiteSpace: "nowrap",
                                                color: "#000000",
                                            }}
                                        >
                                            {ticketData?.[obj.val] || ` `}
                                        </p>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: 'start',
                                padding: '0px 5px'
                            }}
                        >
                            <div style={{ width: "40%" }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಮೂ.ಪ್ರ.ದರ /
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "16px",
                                            lineHeight: "24px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        Journey Fare: {ticketData?.TotalFare || ''}
                                    </p>
                                </div>
                            </div>
                            <div style={{ width: '60%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ರಿಯಾಯಿತಿ / <span style={{ fontSize: '16px' }}>Discount: {Number(ticketData?.DiscountAmount)+Number(ticketData?.KSRTCConcession) || ''}</span>
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಮು.ಬು.ಶು / <span style={{ fontSize: '16px' }}>Res. Fee: {ticketData?.SRTAmount}</span>
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಇತರೆ ಶುಲ್ಕಗಳು / <span style={{ fontSize: '16px' }}>Levies: {Number(ticketData?.BridgeFee) + Number(ticketData?.InsuranceFee) + Number(ticketData?.EntryFee) + Number(ticketData?.InfraFee) + Number(ticketData?.TollFee) + Number(ticketData?.UserFee)}</span>
                                    </p>
                                </div>
                            </div>
                        </div>


                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: 'start',
                                padding: '0px 5px'
                            }}
                        >
                            <div style={{ width: "40%" }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಸ.ಸೇ.ಶು / <span style={{ fontSize: '16px' }}>GST: {ticketData?.ServiceTax} (SGST:{ticketData?.SGST || 0} CGST:{ticketData?.CGST || 0} | GST {ticketData?.IGST || 0})</span>
                                    </p>
                                </div>
                            </div>
                            <div style={{ width: '60%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಒಟ್ಟು (ರೂ.) / <span style={{ fontSize: '16px' }}>Total Amount (Rounded Off): {Number(ticketData?.TotalFare) - Number(ticketData?.KSRTCConcession) + Number(ticketData?.ServiceTax) + Number(ticketData?.BridgeFee) + Number(ticketData?.InsuranceFee) + Number(ticketData?.EntryFee) + Number(ticketData?.InfraFee) + Number(ticketData?.TollFee) + Number(ticketData?.UserFee) + Number(ticketData?.SRTAmount)} </span>
                                    </p>
                                </div>
                            </div>
                        </div>


                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: 'start',
                                padding: '0px 5px'
                            }}
                        >
                            <div style={{ width: "40%" }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಸಹಾಯವಾಣಿ / <span style={{ fontSize: '16px' }}> Call Center: {ticketData?.BranchPhone1}</span>
                                    </p>
                                </div>
                            </div>
                            <div style={{ width: '60%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ರಿಯಾಯಿತಿ ವಿಧ / <span style={{ fontSize: '16px' }}>Concession Type: {ticketData?.ConcessionTypes.split(',')[0]}</span>
                                    </p>
                                </div>
                            </div>
                        </div>

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: 'start',
                                padding: '0px 5px'

                            }}
                        >
                            <div style={{ width: "40%" }}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಪ್ರ. ಹೆಸರು / <span style={{ fontSize: '16px' }}>Name:{ticketData?.name || ''}</span>
                                    </p>
                                </div>
                            </div>
                            <div style={{ width: '60%' }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ವಯಸ್ಸು / <span style={{ fontSize: '16px' }}>Age: {ticketData?.age || ''}</span>
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಲಿಂಗ /<span style={{ fontSize: '16px' }}> Gender: {ticketData?.gender || ''}</span>
                                    </p>
                                    <p
                                        style={{
                                            fontSize: "14px",
                                            lineHeight: "20px",
                                            fontWeight: "500",
                                            whiteSpace: "nowrap",
                                            color: "#000000",
                                        }}
                                    >
                                        ಮೊಬೈಲ್ ನಂ / <span style={{ fontSize: '16px' }}>Mobile No: {ticketData?.CustomerPhone1 || ''}</span>
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: 'start',
                                padding: '0px 5px',
                            }}
                        >
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <p
                                    style={{
                                        fontSize: "14px",
                                        lineHeight: "20px",
                                        fontWeight: "500",
                                        whiteSpace: "nowrap",
                                        color: "#000000",
                                    }}
                                >
                                    ಟಿಕೇಟು ಕಾಯ್ದಿರಿಸಿದ ಮಾಹಿತಿ / <span style={{ fontSize: '16px' }}>Ticket Booked Details: {ticketData?.FromCityShortName},{ticketData?.ToCityShortName},{ticketData?.BookedByBranchCode} {moment(ticketData?.BookingDate).format(`DD-MMM-YYYY`)} {moment(ticketData?.BookingTime).format(`HH:mm:ss`)}</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            }</>
    )
}

export default BkgPrintTicket